import Modal from "../../../../components/element/Modal";
import "../css/AirlineRejectModal.css";


const AirlineRejectModal = ({ isOpen, onClose, onDelete,message }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="airline-reject-modal-content">
        {message}
        <button
          className="airline-reject-modal-delete-button"
          onClick={onDelete}
        >
          Yes
        </button>
      </div>
    </Modal>
  );
};
export default AirlineRejectModal;
